const Footer = () => {
  return (
    <footer className="bg-card border-t border-border py-8">
      <div className="container mx-auto px-4">
        <div className="text-center">
          <h3 className="text-2xl font-bold text-primary mb-2">Gods Garden Church</h3>
          <p className="text-muted-foreground mb-4">
            Growing faith together in love, worship, and service
          </p>
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Gods Garden Church. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
